import {Component, OnInit, ViewChild} from '@angular/core';
import {SearchService} from '../../services/search.service';
import {ProgressComponent} from '../progress/progress.component';
import {BehaviorSubject, Subject} from 'rxjs';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {MatHeaderRow, MatHeaderRowDef, MatTable} from '@angular/material/table';
import {AsyncPipe} from '@angular/common';

@Component({
    selector: 'app-item-search',
    templateUrl: './item-search.component.html',
    styleUrls: ['./item-search.component.scss'],
    imports: [
        ProgressComponent,
        MatTable,
        MatHeaderRow,
        AsyncPipe,
        MatHeaderRowDef
    ],
    standalone: true
})
export class ItemSearchComponent implements OnInit {

    searchKeyFetched: Subject<boolean> = new BehaviorSubject<boolean>(false);
    searchConfig: any = {
        apiKey: '',
        appId: environment.algoliaAppId,
        indexName: 'items',
        // TODO: Enable this when this is resolved https://github.com/algolia/angular-instantsearch/issues/396
        // routing: true,
    };

    @ViewChild(ProgressComponent, {static: true}) progress: ProgressComponent;

    constructor(private searchService: SearchService, private router: Router) {
    }

    ngOnInit() {
        this.searchConfig.apiKey = localStorage.getItem('searchKey');
        if (!this.searchConfig.apiKey) {
            this.progress.setVisible(true);
            this.searchService.getSearchKey().subscribe(result => {
                this.searchConfig.apiKey = result.key;
                localStorage.setItem('searchKey', result.key);
                this.progress.setVisible(false);
                this.searchKeyFetched.next(true);
            });
        } else {
            this.searchKeyFetched.next(true);
        }
    }
}
